var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sections" },
    _vm._l(_vm.sections, function (section, idx) {
      return _c(
        "div",
        { key: section.title, staticClass: "section" },
        [
          section.title
            ? _c("div", { staticClass: "section-title" }, [
                _c("p", { staticClass: "idx-text" }, [
                  _vm._v("\n        " + _vm._s(_vm.getIndexing(idx))),
                  _vm.level === 1 ? _c("span", [_vm._v(".")]) : _vm._e(),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(section.title))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          section.content
            ? _c(
                "div",
                {
                  staticClass: "section-content",
                  class: { "align-by-title": section.title },
                },
                [
                  !section.title && !_vm.autoIndexOff
                    ? _c("p", { staticClass: "idx-text" }, [
                        _vm._v(_vm._s(_vm.getIndexing(idx))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.contentTransform(section.content)),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          section.contentByIndex
            ? _c("div", { staticClass: "section-content" }, [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.indexedContentTransform(idx, section.contentByIndex)
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          section.sections
            ? _c("TermSections", {
                attrs: {
                  sections: section.sections,
                  level: _vm.level + 1,
                  indexText: section.omitPrevIndex ? "" : _vm.getIndexing(idx),
                  indexDelimiter: section.delimiter,
                  autoIndexOff: section.autoIndexOff,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          section.remnantContent
            ? _c("p", { staticClass: "remnant-content" }, [
                _vm._v(_vm._s(section.remnantContent)),
              ])
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }